import type { ReactNode } from 'react';

// The `app/(public)/26-co/layout.tsx` wrapper every page of the edition renders inside,
// nested in `(public)/layout.tsx`'s `<main className="flex-1">`.
//
// Reproduced here rather than skipped (PORTING.md P4) because every surface of these two
// pages is a theme-ph26 token: without it the palette, the fonts and every
// `border-primary` box are wrong, not merely bare. The JSON-LD block and the devtools
// console art the same layout renders are the landing's and belong to
// `sponsors-landing:pages/landing-26-co`, which deletes this file.
export function Ph26Shell({ children }: { children: ReactNode }) {
  return (
    <main className="flex-1">
      <div className="theme-ph26 min-h-screen bg-background font-sans text-foreground">
        {children}
      </div>
    </main>
  );
}
